import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  fetchFMProgramsIfNeeded, fetchZDProgramsIfNeeded
} from '../actions'
import { useEffect } from 'react'

const Grid = (props) => {

  const { programsFM, programsZD, match } = props;

  useEffect( () => { 
    var guide
    const { match, dispatch } = props
    dispatch(fetchFMProgramsIfNeeded())
    dispatch(fetchZDProgramsIfNeeded())
  }, [])
  

  console.log(match)
  let programs = programsFM.items
  if (match.params.station === 'ZD') {
      programs = programsZD.items
  }

  //sort programs into an array of days
  let days = [ { day: 1, name: 'Monday', index: 0, programs: [] } , { day: 2, name: 'Tuesday', index: 0, programs: [] }, { day: 3, name: 'Wednesday', index: 0, programs: []}, { day: 4, name: 'Thursday', index: 0, programs: [] }, { day: 5, name: 'Friday', index: 0, programs: [] }, { day: 6, name: 'Saturday', index: 0, programs: []}, { day: 7, name: 'Sunday', index: 0, programs: [] } ]
  let times = [ '00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00' ]
  let currentday = 0

  if (programs !== null){
    programs.forEach( (program, index) => {
      days[program.day - 1].programs.push(program)
    })
  }



  if (programsZD.items.count !== 0 && programsFM.items.count !== 0 ){
    return (
      <div id="grid">
      <div className="station"><div><Link to="/grid/FM">102.1FM</Link></div><div><Link to="/grid/ZD">ZedDigital</Link></div></div>
      <div className={(match.params.station === 'ZD') ? 'container zd' : 'container fm'}>
      <div className="column">
      <div style={{flex: 1}} className="cell header">
      <div>Time</div>
      </div>
      { times.map((time, i) =>
        <div key={i} style={{order: i, flex: 2}} className="cell time">
        <div>{ time }</div>
        </div>
      )}
      </div>
      { days.map((day, j) =>
        <div key={j} className="column">
        <div style={{flex: 1}} className="cell header">
        <div>{day.name}</div>
        </div>
        { day.programs.map((program, i) =>
          <div key={i} style={{flex: program.duration / 1800 }} className={ program.onairnow ? 'cell onairnow' : 'cell'}>
          <div><Link to={`/program/${program.slug}`}>{ program.name }</Link></div>
          </div>
        )}
        </div>
      )}
      </div>
      </div>
    )
  }
  else {
    return (null)
  }

}

Grid.fetchData = (store) => {
  return Promise.all([
    store.dispatch(fetchFMProgramsIfNeeded()),
    store.dispatch(fetchZDProgramsIfNeeded())
  ])
}

export default connect(state => {return { programsFM: state.programsFM, programsZD: state.programsZD } })(Grid)
